import type { IApplicationState } from '../../types/redux';
import type { IBanner } from '../../types/banners';

export function getBannersByRegionId(state: IApplicationState): IBanner[] {
  const {
    locations: { hash: locationsHash },
    filter: { location },
    banners: { hash: bannersHash },
  } = state;
  const bannerIds = locationsHash[location].bannerIds || [];

  return bannerIds.reduce((acc, id) => {
    const banner = bannersHash[id];

    if (banner) {
      acc.push(banner);
    }

    return acc;
  }, Array.of<IBanner>());
}
